import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function maxDaysPastValidator(maxDays: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value)
            return null;

        const createdDate = new Date(value);
        const now = new Date();

        const diffMs = now.getTime() - createdDate.getTime();
        const diffDays = diffMs / (1000 * 60 * 60 * 24);

        if (diffDays > maxDays) {
            return {
                tooFarInPast: {
                    maxDays,
                    actualDays: diffDays
                }
            }
        }

        return null;
    }
}